import { injectable } from 'inversify';
import { container, TYPES } from '../inversify.config';
import type { IHttpWrapperService } from '../interface/IHttpWrapperService';
import type { 
  IWebhookService, 
  WebhookConfiguration,
  WebhookConfigurationResponse, 
  WebhookConfigurationRequest 
} from '../interface/IWebhookService';


export class WebhookService implements IWebhookService {
  private _httpService: IHttpWrapperService = container.get(TYPES.IHttpWrapperService);

  async GetWebhookDetails(partnerCode: string): Promise<WebhookConfigurationResponse> {
    const response = await this._httpService.getRequest<WebhookConfiguration[]>(
      `webhookconfiguration/getwebhookdetails/${partnerCode}`
    );
    return response.data;
  }

  async UpsertWebhook(request: WebhookConfigurationRequest): Promise<{ isSuccess: boolean; message: string | null }> {
    const response = await this._httpService.postRequest<{ isSuccess: boolean; message: string | null }, WebhookConfigurationRequest>(
      'webhookconfiguration/upsertwebhook',
      request
    );
    return response.data;
  }

  async DeleteWebhook(webhookConfigurationId: number): Promise<{ isSuccess: boolean; message: string | null }> {
    const response = await this._httpService.deleteRequest<{ isSuccess: boolean; message: string | null }, undefined>(
      `webhookconfiguration/deletewebhook/${webhookConfigurationId}`
    );
    return response.data;
  }
}
